import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, from, throwError } from 'rxjs';

@Injectable()
export class AppInterceptor implements HttpInterceptor {

  constructor(
    private snackBar: MatSnackBar,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(catchError(error => {
      if (error.error.message) this.showError(error.error.message);
      return from(throwError(() => error));
    }))
  }

  private showError(error: string) {
    this.snackBar.open(error, undefined, { duration: 3000 });
  }
}